import type {
    SchemaLoanRequestResolver_Find,
    SchemaLoanRequestResolver_GetDuplicateInfoByLead,
    SchemaLoanRequestResolver_GetSummary,
} from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import { currencyFormat, dateTimeFormat } from '~/lib/i18n';

type Props = {
    lead:
        | SchemaLoanRequestResolver_GetSummary[number]
        | (SchemaLoanRequestResolver_Find[number] & {
              antragsteller1: NonNullable<SchemaLoanRequestResolver_Find[number]['antragsteller1']>;
          })
        | SchemaLoanRequestResolver_GetDuplicateInfoByLead[number];
};

export const LeadInfo: React.FC<Props> = ({ lead }) => {
    const { t } = useTranslation();

    return (
        <div className="flex px-4 py-3">
            <div className="flex flex-col text-sm text-midnight gap-1">
                <div className="flex flex-col">
                    {currencyFormat(lead.finanzbedarf.finanzierungswunsch.kreditbetrag ?? 0)}{' '}
                    {t('LEADS.CREDIT_INFO.DATE')}
                    <span>{dateTimeFormat(lead.createdAt)}</span>
                </div>
            </div>
        </div>
    );
};
